<template>
  <div
    class="col-xs-12 col-sm-12 col-md-12 p-0"
    v-if="regFilterPermissisonFlag"
  >
    <div class="reg-filter">
      <div id="registrationFilter">
        <div
          data-toggle="dropdown"
          class="dropdown-filter"
          v-bind:class="{ 'disable-content': disableContent }"
          v-if="collapsed"
          @click="showHideFilter(true)"
        >
          <span class="dropdown-toggle cursor-pointer">
            <img src="/static/images/icons/filter.svg" alt class="image-size" />
            <span class="count" v-if="showFilterIcon">
            <span class="glyphicon glyphicon-ok"></span>
          </span>
            <img
              src="/static/images/icons/chevron_right_grey.svg"
              alt
              class="image-size"
            />
          </span>
        </div>
        <div v-else class="col-xs-12 col-sm-12 col-md-12 col-lg-12 filter-ul dropdown-menu dropdown-menu-left ">
          <div
            class="font-properties cursor-pointer"
            >
            <div class="col-xs-12 plr-0 filter-text">
              <div data-toggle="dropdown" class="col-xs-1 pl-0">
                <a>
                  <img src="/static/images/icons/filter.svg" class="image-size" />
                </a>
              </div>
              <div class="filter col-xs-11">Filter</div>
              <div class="col-xs-1 plr-0 pl-16">
                <a @click="showHideFilter()">
                  <img
                    src="/static/images/icons/chevron_right_grey.svg"
                    class="image-size left-transform"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="col-xs-12 filter-wrapper p-0">
            <div
              @click="filterData('attachment')"
              class="col-xs-12 pr-0 pl-0 cursor-pointer font-properties font-weight-bold item-divider"
              v-if="permissions.indexOf('RECORDS_WITH_ATTACHMENT') > -1"
            >
              <div class="font-weight-bold col-xs-10 pl-0">
                Records With Attachments
              </div>
              <a v-if="is_attachment" class="col-xs-2 p-0 text-right">
                <img src="/static/images/icons/check.svg" class="image-size" />
              </a>
            </div>
            <!-- <div
              @click="filterData('regulatory_alert')"
              class="col-xs-12 pr-0 pl-0 cursor-pointer font-properties font-weight-bold item-divider"
              v-if="permissions.indexOf('AFFECTED_BY_REGULATORY_ALERT') > -1"
            >
              <div class="font-weight-bold col-xs-10 pl-0">
                Affected By Regulatory Alert
              </div>
              <a v-if="is_regulatory_alert" class="col-xs-2 p-0 text-right">
                <img src="/static/images/icons/check.svg" class="image-size" />
              </a>
            </div> -->
            <div>
            <div
              class="col-xs-12 col-md-12 col-lg-12 pr-0 pl-0 cursor-pointer item-divider"
              v-if="permissions.indexOf('APPROVAL_DATES_WITH_OPTIONS') > -1"
              @click="filterRegistrations('collapseApprovalDate','is_approval_date_chevron')">
                <div class="col-xs-10 col-md-10 col-lg-10 p-0">
                  <a
                    class="col-xs-10 font-properties font-weight-bold pl-0"
                    data-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapseExpireyDate"
                    >Approval date</a>
                </div>
                <div class="col-xs-2 pr-0 text-right">
                  <a v-if="!selection.is_approval_date_chevron">
                    <img src="/static/images/icons/chevron_down_grey.svg" class="chev_down" />
                  </a>
                  <a v-else>
                    <img
                      src="/static/images/icons/chevron_down_grey.svg"
                      class="chev_down transform-180"
                    />
                  </a>
                </div>
              </div>
              <div class="col-xs-12 col-md-12 col-lg-12 collapse collapseApprovalDate sub-text pr-0"
              :class="{in: selection.is_approval_date_chevron}"
              >
                <div class="col-xs-12 col-md-12 col-lg-12 p-0">
                  <ul class="pl-0 mt-6 li-none">
                    <li
                      class="col-xs-12 pl-0 pr-0"
                      @click="onApprovalDateChange('last_7_days')"
                    >
                      <div
                        class="col-xs-10 pl-0 sub-approval"
                        :class="{ 'font-bold': is_approval_dt_7_days }"
                      >
                        Last 7 days
                      </div>
                      <a class="col-xs-2 p-0 text-right" v-if="is_approval_dt_7_days">
                        <img
                          src="/static/images/icons/check.svg"
                          class="image-size"
                        />
                      </a>
                    </li>
                    <li
                      class="col-xs-12 pl-0 pr-0"
                      @click="onApprovalDateChange('last_30_days')"
                    >
                      <div
                        class="col-xs-10 pl-0 sub-approval"
                        :class="{ 'font-bold': is_approval_dt_30_days }"
                      >
                        Last 30 days
                      </div>
                      <a
                        class="col-xs-2 p-0 text-right"
                        v-if="is_approval_dt_30_days"
                      >
                        <img
                          src="/static/images/icons/check.svg"
                          class="image-size"
                        />
                      </a>
                    </li>
                    <li
                      class="col-xs-12 pl-0 pr-0"
                      @click="onApprovalDateChange('last_year')"
                    >
                      <div
                        class="col-xs-10 pl-0 sub-approval"
                        :class="{ 'font-bold': is_approval_dt_last_year }"
                      >
                        Within last year
                      </div>
                      <a
                        class="col-xs-2 p-0 text-right"
                        v-if="is_approval_dt_last_year"
                      >
                        <img
                          src="/static/images/icons/check.svg"
                          class="image-size"
                        />
                      </a>
                    </li>
                  </ul>

                  <div class="col-xs-12 pl-0 sub-approval">
                    Date Range
                  </div>
                  <div class="col-xs-12 alert-menu pl-0">
                    <date-picker
                      v-model="start_approval_date"
                      :default-value="
                        start_approval_date ? start_approval_date : new Date()
                      "
                      :disabled-date="notBeforeApprovalEndDate"
                      :editable="false"
                      type="date"
                      placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY"
                      @change="onApprovalDateChange('date_selection')"
                    ></date-picker>
                    <div class="start-to-end">to</div>
                    <date-picker
                      v-model="end_approval_date"
                      :disabled-date="notBeforeApprovalStartDate"
                      :default-value="
                        end_approval_date ? end_approval_date : new Date()
                      "
                      :editable="false"
                      type="date"
                      placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY"
                      @change="onApprovalDateChange('date_selection')"
                    ></date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div
                class="col-xs-12 col-md-12 col-lg-12 pr-0 pl-0 cursor-pointer item-divider"
                v-if="permissions.indexOf('EXPIRATION_DATES') > -1"
                @click="filterRegistrations('collapseExpireyDate','is_expirey_date_chevron')"
              >
                <div class="col-xs-10 col-md-10 col-lg-10 p-0">
                  <a
                    class="col-xs-10 font-properties font-weight-bold pl-0"
                    data-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapseExpireyDate"
                    >Expiration Date</a
                  >
                  </div>
                  <div class="col-xs-2 pr-0 text-right">
                    <a v-if="!selection.is_expirey_date_chevron">
                      <img
                        src="/static/images/icons/chevron_down_grey.svg"
                        class="chev_down"
                      />
                    </a>
                    <a v-else>
                      <img
                        src="/static/images/icons/chevron_down_grey.svg"
                        class="chev_down transform-180"
                      />
                    </a>
                  </div>
                </div>
              <div class="col-xs-12 col-md-12 col-lg-12 collapse collapseExpireyDate sub-text pr-0"
              :class="{in: selection.is_expirey_date_chevron}"
              >
                <div class="col-xs-12 col-md-12 col-lg-12 p-0">
                  <ul class="pl-0 mt-6 li-none">
                    <li
                      class="col-xs-12 pl-0 pr-0"
                      @click="onExpireyDateChange('this_month')"
                    >
                      <div
                        class="col-xs-10 pl-0 sub-approval"
                        :class="{ 'font-bold': is_expirey_dt_this_month }"
                      >
                        This month
                      </div>
                      <a
                        class="col-xs-2 p-0 text-right"
                        v-if="is_expirey_dt_this_month"
                      >
                        <img
                          src="/static/images/icons/check.svg"
                          class="image-size"
                        />
                      </a>
                    </li>
                    <li
                      class="col-xs-12 pl-0 pr-0"
                      @click="onExpireyDateChange('next_3_months')"
                    >
                      <div
                        class="col-xs-10 pl-0 sub-approval"
                        :class="{ 'font-bold': is_expirey_dt_next_3_moths }"
                      >
                        Next 3 months
                      </div>
                      <a
                        class="col-xs-2 p-0 text-right"
                        v-if="is_expirey_dt_next_3_moths"
                      >
                        <img
                          src="/static/images/icons/check.svg"
                          class="image-size"
                        />
                      </a>
                    </li>
                    <li
                      class="col-xs-12 pl-0 pr-0"
                      @click="onExpireyDateChange('within_this_year')"
                    >
                      <div
                        class="col-xs-10 pl-0 sub-approval"
                        :class="{ 'font-bold': is_expirey_dt_within_this_year }"
                      >
                        Within this year
                      </div>
                      <a
                        class="col-xs-2 p-0 text-right"
                        v-if="is_expirey_dt_within_this_year"
                      >
                        <img
                          src="/static/images/icons/check.svg"
                          class="image-size"
                        />
                      </a>
                    </li>
                  </ul>
                  <div class="col-xs-12 pl-0 sub-approval">
                    Date Range
                  </div>
                  <div class="col-xs-12 alert-menu pl-0">
                    <date-picker
                      v-model="start_expirey_date"
                      :default-value="
                        start_expirey_date ? start_expirey_date : new Date()
                      "
                      :disabled-date="notBeforeExpireyEndDate"
                      :editable="false"
                      type="date"
                      placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY"
                      @change="onExpireyDateChange('date_selection')"
                    ></date-picker>
                    <div class="start-to-end">to</div>
                    <date-picker
                      v-model="end_expirey_date"
                      :default-value="
                        end_expirey_date ? end_expirey_date : new Date()
                      "
                      :disabled-date="notBeforeExpireyStartDate"
                      :editable="false"
                      type="date"
                      placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY"
                      @change="onExpireyDateChange('date_selection')"
                    ></date-picker>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div
              class="col-xs-12 col-md-12 col-lg-12 pr-0 pl-0 cursor-pointer item-divider"
              v-if="permissions.indexOf('COUNTRY_WISE_FILTER_AND_SEARCH') > -1"
              @click="filterRegistrations('collapseCountry', 'is_country_chevron')"
              >
              <div class="col-xs-10 col-md-10 col-lg-10 p-0">
                <a
                  class="col-xs-10 font-properties font-weight-bold pl-0"
                  data-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseExpireyDate"
                  >Country</a
                >
                </div>
                <div class="col-xs-2 pr-0 text-right">
                  <a v-if="!selection.is_country_chevron">
                    <img
                      src="/static/images/icons/chevron_down_grey.svg"
                      class="chev_down"
                    />
                  </a>
                  <a v-else>
                    <img
                      src="/static/images/icons/chevron_down_grey.svg"
                      class="chev_down transform-180"
                    />
                  </a>
                </div>
              </div>
              <div class="col-xs-12 col-md-12 col-lg-12 p-0 collapse collapseCountry"
              :class="{in: selection.is_country_chevron}"
              >
                <div class="col-xs-12 countries-list mt-10">
                  <div class="col-xs-12 p-0 search-container-wraper">
                    <div class="search-container reg-search col-xs-12 p-0">
                      <search-box  v-model="searchCountries"  @getList="filterCountriesList()"></search-box>
                    </div>
                  </div>
                  <div
                    class="col-xs-12 p-0 pt-10 element-scroll-bar"
                    v-if="filteredCountriesList.length"
                  >
                    <!-- <el-scrollbar
                      wrap-style="height: 170px !important;"
                      class="col-xs-12 p-0"
                    > -->
                    <el-scrollbar
                      class="col-xs-12 p-0"
                    >
                      <ul v-on:click.stop class="col-xs-12 p-0">
                        <li
                          v-for="country in filteredCountriesList"
                          :key="country.id"
                          class="col-xs-12 p-0"
                        >
                          <div class="col-xs-12 p-0">
                            <div class="col-xs-1 p-0 activityTracker-checkbox">
                              <span class="checkbox">
                                <label>
                                  <input
                                    type="checkbox"
                                    :value="country.id"
                                    v-model="selectedCountryIdList"
                                    @change="selectedCountry()"
                                  />
                                  <span class="cr">
                                      <img class="select-check" src="/static/images/icons/select_check.svg" alt="">
                                    </span>
                                </label>
                              </span>
                            </div>
                            <div class="col-xs-10 p-0">
                              <span
                                class="li-country"
                                :class="{
                                  'font-bold': selectedCountryIdList.indexOf(country.id) > -1
                                  }"
                                >{{ country.country_name }}</span
                              >
                            </div>
                          </div>
                        </li>
                      </ul>
                    </el-scrollbar>
                  </div>
                  <div v-else class="col-xs-12 text-center font-16 mt-10">
                    {{ $t('noCountriesFound') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
              class="col-xs-12 text-right clear-option cursor-pointer pr-0"
              v-if="permissions.indexOf('CLEAR_ALL') > -1"
            >
            <a @click="clearAll">Clear All</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import * as moment from 'moment';
import $ from 'jquery';
import SearchBox from '../UIComponents/SearchBox.vue';
import { getAllCountries } from '../../apis/countriesList';

export default {
  components: {
    DatePicker,
    SearchBox,
  },
  props: {
    regFilterPermissisonFlag: Boolean,
    permissions: Array,
    disableContent: Boolean,
    filterObject: Object,
  },
  data() {
    return {
      selection: {
        is_approval_date_chevron: false,
        is_expirey_date_chevron: false,
        is_country_chevron: false,
      },
      dates: {
        isApprovalDate: false,
        isExpiryDate: false,
      },
      showFilterIcon: false,
      searchCountries: '',
      expand: false,
      collapsed: true,
      z_format: 'T00:00:00.000Z',
      is_approval_dt_7_days: false,
      is_approval_dt_30_days: false,
      is_approval_dt_last_year: false,
      is_expirey_dt_this_month: false,
      is_expirey_dt_next_3_moths: false,
      is_expirey_dt_within_this_year: false,
      is_attachment: false,
      is_regulatory_alert: false,
      is_expirey_date_chevron: true,
      is_approval_date: false,
      is_approval_date_chevron: true,
      is_country: true,
      start_expirey_date: '',
      end_expirey_date: '',
      start_approval_date: '',
      end_approval_date: '',
      countryList: [],
      selectedCountryIdList: [],
      filteredCountriesList: [],
    };
  },
  // watch: {
  //   searchCountries() {
  //     if (!this.searchCountries) this.filterCountriesList();
  //   },
  // },
  methods: {
    filterCountriesList() {
      this.filteredCountriesList = this.countryList.filter((country) => country.country_name
        .toLowerCase()
        .includes(this.searchCountries.toLowerCase()));
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    notBeforeExpireyEndDate(date) {
      if (this.end_expirey_date) {
        return date > new Date(this.end_expirey_date).setHours(0, 0, 0, 0);
      }
      return '';
    },
    notBeforeExpireyStartDate(date) {
      return date < new Date(this.start_expirey_date).setHours(0, 0, 0, 0);
    },
    notBeforeApprovalEndDate(date) {
      if (this.end_approval_date) {
        return date > new Date(this.end_approval_date).setHours(0, 0, 0, 0);
      }
      return '';
    },
    notBeforeApprovalStartDate(date) {
      return date < new Date(this.start_approval_date).setHours(0, 0, 0, 0);
    },
    clearAll() {
      this.searchCountries = '';
      this.is_approval_dt_7_days = false;
      this.is_approval_dt_30_days = false;
      this.is_approval_dt_last_year = false;
      this.is_expirey_dt_this_month = false;
      this.is_expirey_dt_next_3_moths = false;
      this.is_expirey_dt_within_this_year = false;
      this.is_approval_date_chevron = true;
      this.is_expirey_date_chevron = true;
      this.is_attachment = false;
      this.is_regulatory_alert = false;
      this.is_expirey_date = true;
      this.is_approval_date = true;
      this.is_country = true;
      this.start_expirey_date = '';
      this.end_expirey_date = '';
      this.start_approval_date = '';
      this.end_approval_date = '';
      this.selectedCountryIdList = [];
      this.filteredCountriesList = this.countryList;
      this.setDefaultChevronDirections();
      // $('.collapseApprovalDate').removeClass('in');
      // $('.collapseExpireyDate').removeClass('in');
      $('.collapseCountry').removeClass('in');
      const filterObj = { flags: {} };
      // this.filterObject = { flags: {} };
      this.$emit('filterObj', filterObj);
      this.$emit('filterObjectData', filterObj);
    },
    selectedCountry() {
      if (this.selectedCountryIdList.length > 0) {
        this.filterObject.flags.country = true;
      } else {
        delete this.filterObject.flags.country;
      }
      this.filterObject.countries = this.selectedCountryIdList;
      this.$emit('filterObjectData', this.filterObject);
    },
    filterRegistrations(filterCSS, flag) {
      this.selection[flag] = !this.selection[flag];
      // if (flag === 'is_country') {
      //   this.is_country = !this.is_country;
      //   this.selection.isCountry = !this.selection.isCountry;
      // }
      // if (flag === 'is_expirey_date_chevron') {
      //   this.is_expirey_date_chevron = !this.is_expirey_date_chevron;
      //   this.selection.isExpiryDate = !this.selection.isExpiryDate;
      // }
      // if (flag === 'is_approval_date_chevron') {
      //   this.is_approval_date_chevron = !this.is_approval_date_chevron;
      //   this.selection.isApprovalDate = !this.selection.isApprovalDate;
      // }
      if ($(`.${filterCSS}`).hasClass('in')) {
        $(`.${filterCSS}`).removeClass('in');
      } else {
        $(`.${filterCSS}`).addClass('in');
      }
    },

    setDefaultChevronDirections() {
      this.selection = {
        is_approval_date_chevron: false,
        is_expirey_date_chevron: false,
        is_country_chevron: false,
      };
    },

    showHideFilter(expanded = false) {
      this.expand = !this.expand;
      this.collapsed = !this.collapsed;
      if (expanded) {
        if (Object.keys(this.filterObject.flags).length) {
          this.selection.is_approval_date_chevron = !!this.filterObject.flags.approval_date;
          this.selection.is_expirey_date_chevron = !!this.filterObject.flags.expirey_date;
          this.selection.is_country_chevron = !!this.selectedCountryIdList.length;
        } else {
          this.setDefaultChevronDirections();
        }
      } else {
        this.showFilterIcon = this.filterObject.flags && Object.keys(this.filterObject.flags).length;
      }
      if (!this.selection.is_country_chevron && !!this.searchCountries.length) {
        this.searchCountries = '';
      }
      if ($('#registrationFilter').hasClass('open')) {
        // During focus out
        $('#registrationFilter').removeClass('open');
      }
    },
    isApprovalDateStatus(last7days, last30Days, lastYear, dateSelection) {
      if (!dateSelection) {
        // other than date range
        this.start_approval_date = '';
        this.end_approval_date = '';
      }
      this.is_approval_dt_7_days = last7days;
      this.is_approval_dt_30_days = last30Days;
      this.is_approval_dt_last_year = lastYear;
    },
    onApprovalDateChange(data) {
      let dateRangeValidate = true;
      if (data === 'date_selection') {
        if (
          this.start_approval_date !== null
          && this.end_approval_date !== null
          && this.start_approval_date !== ''
          && this.end_approval_date !== ''
        ) {
          // startdate should be lesser than enddate
          this.isApprovalDateStatus(false, false, false, true);
          if (
            moment(this.start_approval_date).format('YYYY-MM-DD')
            <= moment(this.end_approval_date).format('YYYY-MM-DD')
          ) {
            const approvalDateObj = {
              startApprovalDate: this.start_approval_date,
              endApprovalDate: this.end_approval_date,
            };
            this.filterObject.approval_date = approvalDateObj;
            this.filterObject.flags.approval_date = true;
            this.dates.isApprovalDate = true;
          } else {
            this.clearNotifcations();
            this.$notify({
              type: 'error',
              title: 'Date',
              text: 'End Date should be Greater than Start Date',
              group: 'custom-notification',
            });
            this.end_approval_date = '';
          }
        } else {
          if (this.dates.isApprovalDate) {
            if (!this.start_approval_date || !this.end_approval_date) {
              this.dates.isApprovalDate = false;
            }
          } else dateRangeValidate = false;
          delete this.filterObject.approval_date;
          delete this.filterObject.flags.approval_date;
        }
      } else {
        this.dates.isApprovalDate = false;
        let flag = false;
        let startApprovalDate = '';
        let endApprovalDate = '';
        /* is_approval_dt_7_days,last_30_days &  last_year validated for
             2nd time when user clicks on same field */
        if (data === 'last_7_days' && !this.is_approval_dt_7_days) {
          this.isApprovalDateStatus(true, false, false, false);
          startApprovalDate = moment().subtract(7, 'days').format('YYYY-MM-DD') + this.z_format;
          endApprovalDate = moment().format('YYYY-MM-DD') + this.z_format;
          flag = true;
        } else if (data === 'last_30_days' && !this.is_approval_dt_30_days) {
          this.isApprovalDateStatus(false, true, false, false);
          startApprovalDate = moment().subtract(30, 'days').format('YYYY-MM-DD') + this.z_format;
          endApprovalDate = moment().format('YYYY-MM-DD') + this.z_format;
          flag = true;
        } else if (data === 'last_year' && !this.is_approval_dt_last_year) {
          this.isApprovalDateStatus(false, false, true, false);
          const date = moment();
          startApprovalDate = moment(date).year()
            - 1
            + moment(date).format('-01-01')
            + this.z_format;
          endApprovalDate = moment(date).year()
            - 1
            + moment(date).format('-12-31')
            + this.z_format;
          flag = true;
        } else {
          this.isApprovalDateStatus(false, false, false, false);
          flag = false;
        }
        if (flag) {
          // let start_approval_date  = moment().subtract(days, "days").format("YYYY-MM-DD")+ "T00:00:00.000Z"
          // let end_approval_date = moment().format('YYYY-MM-DD')+ "T00:00:00.000Z"
          const approvalDateObj = {
            startApprovalDate,
            endApprovalDate,
          };
          this.filterObject.approval_date = approvalDateObj;
          this.filterObject.flags.approval_date = true;
        } else {
          delete this.filterObject.approval_date;
          delete this.filterObject.flags.approval_date;
        }
      }
      if (dateRangeValidate) {
        this.$emit('filterObjectData', this.filterObject);
      }
    },
    isExpireyDateStatus(thisMonth, next3Months, withinThisYear, dateSelection) {
      if (!dateSelection) {
        // other than date range
        this.start_expirey_date = '';
        this.end_expirey_date = '';
      }
      // Enable/Disable Custom Date
      this.is_expirey_dt_this_month = thisMonth;
      this.is_expirey_dt_next_3_moths = next3Months;
      this.is_expirey_dt_within_this_year = withinThisYear;
    },
    onExpireyDateChange(data) {
      let dateRangeValidate = true;
      if (data === 'date_selection') {
        if (
          this.start_expirey_date !== null
          && this.end_expirey_date !== null
          && this.start_expirey_date !== ''
          && this.end_expirey_date !== ''
        ) {
          if (
            moment(this.start_expirey_date).format('YYYY-MM-DD')
            <= moment(this.end_expirey_date).format('YYYY-MM-DD')
          ) {
            this.isExpireyDateStatus(false, false, false, true);
            const expiretyDateObj = {
              startExpireyDate: this.start_expirey_date,
              endExpireyDate: this.end_expirey_date,
            };
            this.filterObject.expirey_date = expiretyDateObj;
            this.filterObject.flags.expirey_date = true;
            this.dates.isExpiryDate = true;
          } else {
            this.clearNotifcations();
            this.$notify({
              type: 'error',
              title: 'Date',
              text: 'End Date should be Greater than Start Date',
              group: 'custom-notification',
            });
            this.end_expirey_date = '';
          }
        } else {
          if (this.dates.isExpiryDate) {
            if (!this.start_expirey_date || !this.end_expirey_date) {
              this.dates.isExpiryDate = false;
            }
          } else dateRangeValidate = false;
          delete this.filterObject.expirey_date;
          delete this.filterObject.flags.expirey_date;
        }
      } else {
        this.dates.isExpiryDate = false;
        let flag = false;
        let startExpireyDate = '';
        let endExpireyDate = '';
        /* is_expirey_dt_this_month,is_expirey_dt_next_3_moths &  is_expirey_dt_within_this_year
                validated for 2nd time when user clicks on same field */
        if (data === 'this_month' && !this.is_expirey_dt_this_month) {
          // current month
          this.isExpireyDateStatus(true, false, false, false); // Enable this month
          startExpireyDate = moment().format('YYYY-MM-01') + this.z_format;
          endExpireyDate = moment().format('YYYY-MM-')
            + moment().daysInMonth()
            + this.z_format;
          flag = true;
        } else if (
          data === 'next_3_months'
          && !this.is_expirey_dt_next_3_moths
        ) {
          // Current month+1 to 3 months
          this.isExpireyDateStatus(false, true, false, false); // Enable next months
          // startExpireyDate = moment().format("YYYY-MM-01")+ this.z_format
          startExpireyDate = moment(moment().add(1, 'months')).format('YYYY-MM-01')
            + this.z_format;
          const futureDate = moment().add(3, 'months'); // Date will be returned
          endExpireyDate = moment(futureDate).format('YYYY-MM-')
            + futureDate.daysInMonth()
            + this.z_format;
          flag = true;
        } else if (
          data === 'within_this_year'
          && !this.is_expirey_dt_within_this_year
        ) {
          // Current date to end of the year
          const date = moment();
          startExpireyDate = moment().format('YYYY-MM-DD') + this.z_format;
          // startExpireyDate = moment(date).year()+moment(date).format("-01-01")+this.z_format
          endExpireyDate = moment(date).year() + moment(date).format('-12-31') + this.z_format;
          this.isExpireyDateStatus(false, false, true, false); // Enable within this year
          flag = true;
        } else {
          this.isExpireyDateStatus(false, false, false, false); // Disable All
          flag = false;
        }
        if (flag) {
          const expiretyDateObj = {
            startExpireyDate,
            endExpireyDate,
          };
          this.filterObject.expirey_date = expiretyDateObj;
          this.filterObject.flags.expirey_date = true;
        } else {
          delete this.filterObject.expirey_date;
          delete this.filterObject.flags.expirey_date;
        }
      }
      if (dateRangeValidate) {
        this.$emit('filterObjectData', this.filterObject);
      }
    },
    filterData(data) {
      if (data === 'attachment') {
        this.is_attachment = !this.is_attachment;
        if (this.is_attachment) {
          this.filterObject.flags.attachment = true;
        } else {
          delete this.filterObject.flags.attachment;
        }
        this.$emit('filterObjectData', this.filterObject);
      }
      if (data === 'regulatory_alert') {
        this.is_regulatory_alert = !this.is_regulatory_alert;
        if (this.is_regulatory_alert) {
          this.filterObject.flags.regulatory_alert = true;
        } else {
          delete this.filterObject.flags.regulatory_alert;
        }
        this.$emit('filterObjectData', this.filterObject);
      }
      // if (data ==='approval_dt_last_7') {
      //   this.is_approval_dt_7_days = !this.is_approval_dt_7_days;
      //   if (this.is_approval_dt_7_days) {
      //     this.filterObject.flags.approval_dt_last_7 = true;
      //     alertObj = {
      //       startAlertDate: moment()
      //         .subtract(7, 'days')
      //         .format('YYYY-MM-DD'),
      //       endAlertDate: moment().format('YYYY-MM-DD'),
      //     };
      //     this.filterObject.approval_dt_last_7_obj = expiretyDateObj;
      //   } else {
      //     delete this.filterObject.flags.approval_dt_last_7;
      //   }
      //   this.$emit('filterObjectData', this.filterObject);
      // }
    },
    async getCountryList() {
      let countryListStorage = '';
      countryListStorage = await getAllCountries();
      this.countryList = countryListStorage;
      this.filteredCountriesList = countryListStorage;
    },
  },
  created() {
    this.getCountryList();
  },
};
</script>
<style scoped>
.select-check {
  height: 11px;
  width: 13px;
  position: absolute;
  left: 1px;
  top: 2px;
}
.li-country {
  vertical-align: middle;
}
.reg-search .vertical-line {
  top: 7px;
  right: 35px;
  position: absolute;
  border-left: 1px solid #dfe1e5;
  height: 66%;
}
.reg-search .search-box {
  padding: 0px 45px 0 15px;
  border-color: 1px solid#828282;
}
.reg-search .search-reset {
  top: 6px;
  right: 40px;
}
.reg-search img {
  width: 20px;
  height: 18px;
}
.reg-search .p-absolute {
  top: 8px;
  position: absolute;
  right: 10px;
}
.countries-list {
  border: 1px solid #d3d6d9;
  box-sizing: border-box;
  border-radius: 4px;
  height: 250px;
  padding: 15px 5px 0px 15px;
}
.countries-list ul {
  list-style-type: none;
  padding: 0;
  z-index: 1;
  border-radius: 10px;
  border: none;
  max-height: 200px;
}

.countries-list ul li {
  color: #0B3C61;
  padding: 0px 5px 5px 0px;
  font-size: 16px;
}
.search-container-wraper {
  padding-right: 10px;
}
.ml-5 {
  margin-left: 5px;
}
.ft-18 {
  font-size: 18px;
}
/* .reg-filter {
  position: absolute;
  margin: 6px 0px 0px 1px;
  z-index: 1;
} */

.reg-filter {
  position: absolute;
  z-index: 3;
  left: 15px;
  top: -4px;
  margin-left: -20px;
}

.chev_down {
  height: 18px;
  width: 10px;
}
.filter-text {
  display: inline-flex;
  padding-bottom: 18px;
}
.collapseApprovalDate.in,
.collapseExpireyDate.in {
  border-bottom: 1px solid #D3D6D9;
  padding-bottom: 10px;
}
.element-scroll-bar >>> .el-scrollbar__wrap {
  height: 198px!important;
  margin-bottom: -25px!important;
  margin-right: -25px!important;
}
.element-scroll-bar >>> .el-scrollbar__bar {
  opacity: 1!important;
}
.activityTracker-checkbox > .checkbox .cr {
  width: 18px;
  height: 18px;
}
.li-none {
  list-style: none;
}
.dropdown {
  display: inline-block;
}
/* .dropdown-filter {
  margin-top: 5px;
} */
.dropdown-filter {
  margin-top: 5px;
  height: 46px;
  padding: 9px;
  background: #ffffff;
  -webkit-box-shadow: 0px 4px 10px rgb(0 0 0 / 25%);
  box-shadow: 0px 4px 10px rgb(0 0 0 / 25%);
  border-radius: 0px 4px 4px 0px;
}
.filter-ul {
  margin: 0px;
  padding: 16px 16px 16px 24px;
  width: 375px;
  display: block;
  background:#ffffff;
  scrollbar-width: thin;
}
.filter-wrapper {
  padding-right: 7px;
  height: 376px;
  overflow: auto;
}
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-thumb {
  background: #CDCDCD;
  border-radius: 20px;
}
::-webkit-scrollbar-thumb:hover {
  background: #CDCDCD;
}
.filter {
  font-family: 'Open Sans';
  font-style: normal;
  font-size: 16px;
  line-height: 19px;
  color: #0b3c61;
  font-weight: 500;
  padding: 2px 0 0 0;
}
.font-properties {
  font-family: 'Open Sans';
  font-style: normal;
  font-size: 16px;
  line-height: 19px;
  color: #0b3c61;
}
.font-weight-normal {
  font-weight: normal;
}
.font-weight-bold {
  font-weight: 500;
}
.image-size {
  height: 18px;
  width: 18px;
}
.el-input {
  width: 45% !important;
}
.alert-menu >>> .el-input--suffix .el-input__inner {
  padding-right: 0px;
}
.el-tag {
  background-color: transparent;
  border: transparent;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #0b3c61;
}
.country-list {
  overflow: auto;
  margin: 1px 1px 1px 2px;
  position: absolute;
  width: 214px;
  height: 170px;
  background: #ffffff;
  border: 1px solid #828282;
  box-sizing: border-box;
  border-radius: 3px;
}
.country-obj {
  border: hidden;
  padding: 5px 1px 1px 3px;
}
.selected-country {
  color: #0b3c61 !important;
}
.item-divider {
  border-bottom: 1px solid #D3D6D9;
  padding-bottom: 7px;
  margin-top: 6px;
}
.plr-0 {
  padding-left: 0;
  padding-right: 0;
}
.pb-1 {
  padding-bottom: 1px;
}
.pl-26 {
  padding-left: 26px;
}
.pl-13 {
  padding-left: 13px;
}
.pl-16 {
  padding-left: 16px;
}
.dropdown-menu > li > a {
  padding: 0px 0px 0px 26px;
  clear: none;
  bottom: 5px;
}
.sub-text {
  padding-bottom: 13px;
  /* padding-left: 12px; */
}
.start-to-end {
  font-size: 14px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.7);
  padding: 10px 8px;
  display: inline;
}
.search-country {
  border: 0.5px solid #828282;
  box-sizing: border-box;
  border-radius: 14px;
  margin-left: 40px;
  padding-left: 45px;
}
.clear-all {
  float: left;
  background: rgb(255, 255, 255);
  height: 25px;
  padding: 1px 12px;
  font-size: 16px;
}
.clear-option a {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #0b3c61;
}

.search-container .search-input {
  width: 214px;
}
.has-search .form-control {
  border-radius: 20px;
  padding-right: 12px;
  padding-left: 34px;
  border: 1px solid #828282;
}
.has-search .form-control-feedback {
  right: initial;
  left: 2px;
  color: #0b3c61;
}
.country-divider {
  margin: 7px 0;
  overflow: hidden;
  height: 0;
  border-bottom: 1px solid #d3d6d9;
}
.alert-menu {
  margin-top: 0px;
}
.alert-menu .mx-datepicker {
  width: 124px;
}
.alert-menu .mx-datepicker >>> .mx-input {
  padding: 4px 6px 4px 32px;
  font-size: 13px;
  color: #3E3E3E;
  border: 0.5px solid #3E3E3E;
  border-radius: 3px;
  font-weight: 300;
}
.alert-menu .mx-datepicker >>> .mx-input-wrapper .mx-icon-calendar {
  left: 8px;
}
.alert-menu .mx-datepicker >>> .mx-input-wrapper .mx-icon-clear {
  right: 98px;
}
.alert-menu >>> .el-input--suffix .el-input__inner {
  padding-right: 0px;
}
.left-transform {
  transform: rotate(-180deg);
}
.records-country-tag {
  padding-top: 2px;
}
.records-country-tag >>> .el-icon-close {
  background-color: transparent;
  color: #d8212b;
}
.sub-approval {
  color: #3E3E3E;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 13px;
}
.sub-approval.font-bold {
  font-weight: bold;
}
.mt-6 {
  margin-top: 6px;
}
.element-scroll-bar >>> .el-scrollbar {
  padding-bottom: 6px;
}

.count {
  position: absolute;
  left: 19px;
  top: 8px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  line-height: 16px;
  font-size: 9px;
  text-align: center;
  cursor: pointer;
  color: white;
  background: #4c9e45;
}

@media (min-width: 1025px) and (max-width: 1280px) {
  .image-size {
    height: 15px;
    width: 15px;
  }
  .font-properties {
    font-size: 12px;
  }
  .filter {
    font-size: 14px;
  }
  .filter-ul {
    width: 280px;
  }
  .li-country {
    padding-left: 8px;
  }
}
@media only screen and (min-width: 1517px) {
  .element-scroll-bar >>> .el-scrollbar {
    padding-bottom: 0px;
  }
}
@media only screen and (max-width: 1024px) {
  .countries-list {
    height: 270px;
  }
  .element-scroll-bar >>> .el-scrollbar {
    padding-bottom: 20px;
  }
}
</style>
